import { render, staticRenderFns } from "./VerticalSwiper.vue?vue&type=template&id=4e1b684d&scoped=true&"
import script from "./VerticalSwiper.vue?vue&type=script&lang=js&"
export * from "./VerticalSwiper.vue?vue&type=script&lang=js&"
import style0 from "./VerticalSwiper.vue?vue&type=style&index=0&id=4e1b684d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1b684d",
  null
  
)

export default component.exports